import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson45: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center pt-[2.69rem] px-[2.69rem] pb-[7.63rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson44"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">Micronutrients</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson46"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="w-full flex flex-col items-center justify-center gap-[9.63rem] max-w-[125rem] text-justify text-white font-dm-sans">
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            Micronutrients are one of the major groups of nutrients your body
            needs. They include vitamins and minerals.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Vitamins are necessary for energy production, immune function, blood
            clotting and other functions. Meanwhile, minerals play an important
            role in growth, bone health, fluid balance and several other
            processes.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            This article provides a detailed overview of micronutrients, their
            functions and implications of excess consumption or deficiency.
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem]">
              <b>
                <span>What Are Micronutrients?</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    The term micronutrients is used to describe vitamins and
                    minerals in general.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Macronutrients, on the other hand, include proteins, fats
                    and carbohydrates.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Your body needs smaller amounts of micronutrients relative
                    to macronutrients. That’s why they’re labelled “micro.”
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Humans must obtain micronutrients from food since your body
                    cannot produce vitamins and minerals — for the most part.
                    That’s why they’re also referred to as essential nutrients.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Vitamins are organic compounds made by plants and animals
                    which can be broken down by heat, acid or air. On the other
                    hand, minerals are inorganic, exist in soil or water and
                    cannot be broken down.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    When you eat, you consume the vitamins that plants and
                    animals created or the minerals they absorbed.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    The micronutrient content of each food is different, so it’s
                    best to eat a variety of foods to get enough vitamins and
                    minerals.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    An adequate intake of all micronutrients is necessary for
                    optimal health, as each vitamin and mineral has a specific
                    role in your body.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Vitamins and minerals are vital for growth, immune function,
                    brain development and many other important functions.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Depending on their function, certain micronutrients also
                    play a role in preventing and fighting disease.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>The Six MicroNutrient Commandments :</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <ul className="m-0 block pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <i>
                      Make it a goal to include at least three or four servings
                      of green vegetables in your daily meals.
                    </i>
                  </span>
                </span>
              </li>
            </ul>
            <ul className="m-0 block pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <i>{`One serving is typically equivalent to "1 cup" of vegetables. For example, you can have 1 cup of broccoli (around 100g raw) or approximately 10 broccoli florets. Another option is 100g of raw spinach (roughly 3 & 1/3 cups raw or 1/2 cup cooked), or you can go for 1/2 cup of asparagus (about 65g or 6 spears).`}</i>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <i>&nbsp;</i>
                </span>
              </span>
            </p>
            <ul className="m-0 block pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <i>Aim for a minimum of two servings of fruit each day.</i>
                  </span>
                </span>
              </li>
            </ul>
            <ul className="m-0 block pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <i>
                      One serving can be represented by a single kiwi or one
                      banana, typically weighing between 80-150g depending on
                      the fruit.
                    </i>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <i>&nbsp;</i>
                </span>
              </span>
            </p>
            <ul className="m-0 block pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <i>
                      Strive to incorporate a variety of fruits and vegetables
                      with different colors into your diet. Rotate your food
                      sources regularly.
                    </i>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <i>&nbsp;</i>
                </span>
              </span>
            </p>
            <ul className="m-0 block pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <i>
                      Include fatty fish in your diet once or twice a week.
                      Alternatively, consider taking fish oil supplements .
                    </i>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <i>&nbsp;</i>
                </span>
              </span>
            </p>
            <ul className="m-0 block pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <i>
                      Maintain a balanced and diverse diet. If you choose to
                      eliminate grains, dairy, or meat, it may be necessary to
                      supplement certain nutrients like vitamin B12, vitamin D,
                      omega-3 fatty acids, iodine, iron, calcium, and zinc under
                      the guidance of a medical professional.
                    </i>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <i>&nbsp;</i>
                </span>
              </span>
            </p>
            <ul className="m-0 block pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <i>
                      Generally, focus on consuming whole foods that are
                      minimally processed and rich in nutrients.
                    </i>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Taking these commandments into consideration, the primary
                    emphasis of this section will be on the macronutrients, as
                    they, along with total calorie intake, play a crucial role
                    in body recomposition. Let's begin by discussing the most
                    vital macronutrient among the three: protein.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>&nbsp;</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>SUMMARY</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>&nbsp;</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Micronutrients include vitamins and minerals. They’re
                    critical for several important functions in your body and
                    must be consumed from food.
                  </span>
                </span>
              </span>
            </p>
          </div>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Types and Functions of Micronutrients</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Vitamins and minerals can be divided into four categories:
                water-soluble vitamins, fat-soluble vitamins, microminerals and
                trace minerals.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Regardless of type, vitamins and minerals are absorbed in
                similar ways in your body and interact in many processes.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem]">
              <b>
                <span>Water-Soluble Vitamins</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Most vitamins dissolve in water and are therefore known as
                    water-soluble. They’re not easily stored in your body and
                    get flushed out with urine when consumed in excess.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    While each water-soluble vitamin has a unique role, their
                    functions are related.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    For example, most B vitamins act as coenzymes that help
                    trigger important chemical reactions. A lot of these
                    reactions are necessary for energy production.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    The water-soluble vitamins — with some of their functions —
                    are:
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <b className="font-dm-sans">Vitamin B1 (thiamine):</b>
                    <span> Helps convert nutrients into energy.</span>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <b className="font-dm-sans">Vitamin B2 (riboflavin):</b>
                    <span>
                      {" "}
                      Necessary for energy production, cell function and fat
                      metabolism.
                    </span>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <b>&nbsp;</b>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <b>Vitamin B3 (niacin):</b>
                    <span> Drives the production of energy from food.</span>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <b className="font-dm-sans">{`Vitamin B5 (pantothenic acid): `}</b>
                    <span>Necessary for fatty acid synthesis.</span>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <b>&nbsp;</b>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <b>Vitamin B6 (pyridoxine):</b>
                    <span>
                      {" "}
                      Helps your body release sugar from stored carbohydrates
                      for energy and create red blood cells.
                    </span>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <b className="font-dm-sans">Vitamin B7 (biotin):</b>
                    <span>
                      {" "}
                      Plays a role in the metabolism of fatty acids, amino acids
                      and glucose.
                    </span>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <b>&nbsp;</b>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <b>Vitamin B9 (folate):</b>
                    <span> Important for proper cell division.</span>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <b className="font-dm-sans">Vitamin B12 (cobalamin):</b>
                    <span>
                      {" "}
                      Necessary for red blood cell formation and proper nervous
                      system and brain function.
                    </span>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <b className="font-dm-sans">Vitamin C (ascorbic acid):</b>
                    <span>
                      {" "}
                      Required for the creation of neurotransmitters and
                      collagen, the main protein in your skin.
                    </span>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    As you can see, water-soluble vitamins play an important
                    role in producing energy but also have several other
                    functions.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Since these vitamins are not stored in your body, it’s
                    important to get enough of them from food.
                  </span>
                </span>
              </span>
            </p>
          </div>
        </div>
        <img
          className="relative w-[96.88rem] h-[36.5rem] object-cover"
          alt=""
          src="/259@2x.png"
        />
        <div className="self-stretch flex flex-row items-center justify-center text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem]">
              <b>
                <span>Fat-Soluble Vitamins</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>Fat-soluble vitamins do not dissolve in water.</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    They’re best absorbed when consumed alongside a source of
                    fat. After consumption, fat-soluble vitamins are stored in
                    your liver and fatty tissues for future use.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    The names and functions of fat-soluble vitamins are:
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <b className="font-dm-sans">{`Vitamin A: `}</b>
                    <span>Necessary for proper vision and organ function.</span>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <b className="font-dm-sans">Vitamin D:</b>
                    <span>
                      {" "}
                      Promotes proper immune function and assists in calcium
                      absorption and bone growth.
                    </span>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <b className="font-dm-sans">Vitamin E:</b>
                    <span>
                      {" "}
                      Assists immune function and acts as an antioxidant that
                      protects cells from damage.
                    </span>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <b>&nbsp;</b>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li>
                <span>
                  <span>
                    <b>{`Vitamin K: `}</b>
                    <span>
                      Required for blood clotting and proper bone development.
                    </span>
                  </span>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <img
          className="relative w-[96.75rem] h-[18.25rem] object-cover"
          alt=""
          src="/260@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Microminerals</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Microminerals are needed in larger amounts than trace minerals
                  in order to perform their specific roles in your body.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>The microminerals and some of their functions are:</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>Calcium:</b>
                  <span>
                    {" "}
                    Necessary for proper structure and function of bones and
                    teeth. Assists in muscle function and blood vessel
                    contraction.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Phosphorus:</b>
                  <span> Part of bone and cell membrane structure.</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Magnesium:</b>
                  <span>
                    {" "}
                    Assists with over 300 enzyme reactions, including regulation
                    of blood pressure.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>Sodium:</b>
                  <span>
                    {" "}
                    Electrolyte that aids fluid balance and maintenance of blood
                    pressure.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>{`Chloride: `}</b>
                  <span>
                    Often found in combination with sodium. Helps maintain fluid
                    balance and is used to make digestive juices.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>{`Potassium: `}</b>
                  <span>
                    Electrolyte that maintains fluid status in cells and helps
                    with nerve transmission and muscle function.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  <b className="font-dm-sans">{`Sulfur: `}</b>
                  <span>
                    Part of every living tissue and contained in the amino acids
                    methionine and cysteine.
                  </span>
                </span>
              </span>
            </li>
          </ul>
        </div>
        <img
          className="relative w-[96.75rem] h-[28rem] object-cover"
          alt=""
          src="/261@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Trace Minerals</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Trace minerals are needed in smaller amounts than
                  microminerals but still enable important functions in your
                  body.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>The trace minerals and some of their functions are:</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Iron: `}</b>
                  <span>
                    Helps provide oxygen to muscles and assists in the creation
                    of certain hormones.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>Manganese:</b>
                  <span>
                    {" "}
                    Assists in carbohydrate, amino acid and cholesterol
                    metabolism.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Copper:</b>
                  <span>
                    {" "}
                    Required for connective tissue formation, as well as normal
                    brain and nervous system function.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>Zinc:</b>
                  <span>
                    {" "}
                    Necessary for normal growth, immune function and wound
                    healing.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Iodine:</b>
                  <span> Assists in thyroid regulation.</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>Fluoride:</b>
                  <span>
                    {" "}
                    Necessary for the development of bones and teeth.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  <b>Selenium:</b>
                  <span>
                    {" "}
                    Important for thyroid health, reproduction and defence
                    against oxidative damage.
                  </span>
                </span>
              </span>
            </li>
          </ul>
        </div>
        <img
          className="relative w-[96.75rem] h-[26rem] object-cover"
          alt=""
          src="/262@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            <b>SUMMARY </b>
          </p>
          <p className="m-0">
            Micronutrients can be divided into four groups — water-soluble
            vitamins, fat-soluble vitamins, microminerals and trace minerals.
            The functions, food sources and recommended intakes of each vitamin
            and mineral vary.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Health Benefits of Micronutrients</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  All micronutrients are extremely important for the proper
                  functioning of your body.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Consuming an adequate amount of the different vitamins and
                  minerals is key to optimal health and may even help fight
                  disease.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  This is because micronutrients are part of nearly every
                  process in your body. Moreover, certain vitamins and minerals
                  can act as antioxidants.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Antioxidants may protect against cell damage that has been
                  associated with certain diseases, including cancer,
                  Alzheimer’s and heart disease.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  For example, research has linked an adequate dietary intake of
                  vitamins A and C with a lower risk of some types of cancer.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Getting enough of some vitamins may also help prevent
                  Alzheimer’s disease. A review of seven studies found that
                  adequate dietary intake of vitamins E, C and A is associated
                  with a 24%, 17% and 12% reduced risk of developing
                  Alzheimer’s, respectively.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Certain minerals may also play a role in preventing and
                  fighting disease.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Research has linked low blood levels of selenium to a higher
                  risk of heart disease. A review of observational studies found
                  that the risk of heart disease decreased by 24% when blood
                  concentrations of selenium increased by 50%.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Additionally, a review of 22 studies noticed that adequate
                  calcium intake decreases the risk of death from heart disease
                  and all other causes.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  These studies suggest that consuming enough of all
                  micronutrients — especially those with antioxidant properties
                  — provides ample health benefits.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  However, it’s unclear whether consuming more than the
                  recommended amounts of certain micronutrients — either from
                  foods or supplements — offers additional benefits.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Micronutrients are part of nearly every process in your body.
                  Some even act as antioxidants. Due to their important role in
                  health, they may protect against diseases.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Micronutrient Deficiencies and Toxicities</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Micronutrients are needed in specific amounts to perform their
                unique functions in your body.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Getting too much or too little of a vitamin or mineral can lead
                to negative side effects.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Deficiencies</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Most healthy adults can get an adequate amount of
                  micronutrients from a balanced diet, but there are some common
                  nutrient deficiencies that affect certain populations.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>These include:</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>{`Vitamin D: `}</b>
                  <span>
                    Approximately 77% of Americans are deficient in vitamin D,
                    mostly due to lack of sun exposure.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Vitamin B12:</b>
                  <span>
                    {" "}
                    Vegans and vegetarians may develop vitamin B12 deficiency
                    from refraining from animal products. Elderly individuals
                    are also at risk due to decreased absorption with age.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Vitamin A:</b>
                  <span>
                    {" "}
                    The diets of women and children in developing countries
                    often lack adequate vitamin A.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Iron:</b>
                  <span>{` Deficiency of this mineral is common among preschool children, menstruating women & vegans.`}</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>Calcium:</b>
                  <span>
                    {" "}
                    Close to 22% and 10% of men and women over 50, respectively,
                    don’t get enough calcium.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  The signs, symptoms and long-term effects of these
                  deficiencies depend on each nutrient but can be detrimental to
                  the proper functioning of your body and optimal health.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Toxicities</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Micronutrient toxicities are less common than deficiencies.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                They are most likely to occur with large doses of the
                fat-soluble vitamins A, D, E and K since these nutrients can be
                stored in your liver and fatty tissues. They cannot be excreted
                from your body like water-soluble vitamins.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                A micronutrient toxicity usually develops from supplementing
                with excess amounts — rarely from food sources. Signs and
                symptoms of toxicity vary depending on the nutrient.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                It’s important to note that excessive consumption of certain
                nutrients can still be dangerous even if it does not lead to
                overt toxicity symptoms.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                One study examined over 18,000 people with a high risk of lung
                cancer due to past smoking or asbestos exposure. The
                intervention group received two types of vitamin A — 30 mg of
                beta-carotene and 25,000 IU of retinyl palmitate a day.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                The trial was halted ahead of schedule when the intervention
                group showed 28% more cases of lung cancer and a 17% greater
                incidence of death over 11 years compared to the control group.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Micronutrient Supplements</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  The safest and most effective way to get adequate vitamin and
                  mineral intake appears to be from food sources.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  More research is needed to fully understand the long-term
                  effects of toxicities and supplements.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  However, people at risk of specific nutrient deficiencies may
                  benefit from taking supplements under the supervision of a
                  doctor.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  If you’re interested in taking micronutrient supplements, look
                  for products certified by a third party. Unless otherwise
                  directed by a healthcare provider, be sure to avoid products
                  that contain “super” or “mega” doses of any nutrient.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Since your body requires micronutrients in specific amounts,
                  deficiencies and surpluses of any one nutrient may lead to
                  negative issues. If you’re at risk of a specific deficiency,
                  talk to your doctor before starting supplements.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] inline-block h-[18.13rem] shrink-0 text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>The Bottom Line</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                The term micronutrients refers to vitamins and minerals, which
                can be divided into microminerals, trace minerals and water- and
                fat-soluble vitamins.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Vitamins are needed for energy production, immune function,
                blood clotting and other functions while minerals benefit
                growth, bone health, fluid balance and other processes.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                To get an adequate amount of micronutrients, aim for a balanced
                diet containing a variety of foods.
              </span>
            </span>
          </p>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson46"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
      </div>
    </div>
  );
};

export default Lesson45;
